/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Status_Document_ErrorInputs */

const en_so_status_document_error = /** @type {(inputs: So_Status_Document_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document failed`)
};

/**
* | output |
* | --- |
* | "Document failed" |
*
* @param {So_Status_Document_ErrorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_status_document_error = /** @type {((inputs?: So_Status_Document_ErrorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Status_Document_ErrorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_status_document_error(inputs)
});